/**
 * Also fix for the absent console in IE9
 */
if (!window.console)
{
    window.console = {};
    window.console.log = window.console.assert = function(){};
    window.console.warn = window.console.assert = function(){};
}



//////////////////
// WEBPACK FOOTER
// ./polyfills/console.js
// module id = 397
// module chunks = 0